let sent = false;

document.addEventListener('submit', (e) => {
  if(e.target.matches('#form--call-me-back') && ! sent) {
    handleRecallFormSubmit(e);
    try {
      dataLayer.push({
        'event': 'callBackSubmit',
        'phone': e.target.querySelector('#recall_phone').value
      });
    } catch (e) {
    }
  }
}, false);

function createElementFromHTML(htmlString) {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes.
  return div.firstChild;
}

function handleRecallFormSubmit(e) {
  e.preventDefault();

  sent = true;

  let formData = new FormData(),
    form = Object.fromEntries(new FormData(e.target));

  Object.keys(form).forEach(function (item) {
    formData.append(item, form[item]);
  });

  formData.append('action', 'submit-recall-form-ajax');
  let params = new URLSearchParams(formData);
  fetch(urls.ajax, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache',
    },
    body: params
  }).then(response => {
    return response.json();
  }).then(response => {
    let parent = document.getElementById('form--call-me-back').parentElement;
    let funnelSidebar= document.querySelector('.funnel-sidebar-content');

    parent.querySelector('.message.success')?.remove();
    parent.querySelector('form').remove();
    parent.appendChild(createElementFromHTML(response.data.template));
    let script = parent.querySelector('script');
    if (script !== null) {
      eval(script.innerHTML);
    }
    let formCallback = document.getElementById('form--call-me-back');

    formCallback.onsubmit = function(e) {
      handleRecallFormSubmit(e);
    }

    if (response.success) {
      let successDiv = document.createElement('div');
      successDiv.className = 'display--block message success';
      successDiv.innerHTML = response.data.message;
      parent.insertBefore(successDiv, formCallback);

      let formBtnLoader = document.querySelector('.lds-default');
      let formErrors = document.querySelectorAll('.error-message');

      if (formBtnLoader) {
        formBtnLoader.remove();
      }

      if (formErrors) {
        formErrors.forEach(formError => formError.remove());
      }
    } else {
      if (funnelSidebar) {
        document.getElementById('call_me_back').setAttribute('checked', 'checked');
      }
    }

    if (funnelSidebar) {
      let callMeBackCheckbox = document.getElementById('call_me_back');

      function handleCheckboxChange() {
        if (callMeBackCheckbox.checked) {
          let sucessMessage = document.querySelector('.message.success');

          if (sucessMessage) {
              sucessMessage.remove();
          }
        }
      }

      callMeBackCheckbox.addEventListener('change', handleCheckboxChange);
    }

    sent = false;
  });
}

// Delete spaces in input tel
document.addEventListener("DOMContentLoaded", function () {
  const phoneInputs = document.querySelectorAll('input[type="tel"]');

  phoneInputs.forEach((input) => {
      input.addEventListener('input', function() {
          this.value = this.value.replace(/\s+/g, '');
      });
  });
});
